class MediaGallery extends HTMLElement {
  constructor() {
    super();

    this.viewer = this.querySelector('[data-gallery-viewer]');
    this.thumbnails = this.querySelector('[data-gallery-thumbnails]');

    if (!this.viewer || !this.thumbnails) return;

    this.thumbnails.addEventListener('click', this.onThumbnailClick.bind(this));

    this.viewer.addEventListener('slideChanged', (event) => {
      const mediaId = event.detail.currentElement.dataset.mediaId;
      const thumbnail = this.thumbnails.querySelector(`[data-target="${mediaId}"]`);
      this.setActiveThumbnail(thumbnail);

      this.announceSlide(event.detail.currentPage);
    });

    // Accessibility
    this.setAttribute('role', 'region');
    this.setAttribute('aria-label', 'Product media gallery');
    this.liveRegion = this.querySelector('[id^="GalleryStatus"]');
  }

  onThumbnailClick(event) {
    const thumbnailItem = event.target.closest('[data-target]');
    if (!thumbnailItem) return;

    const mediaId = thumbnailItem.dataset.target;
    this.setActiveSlide(mediaId);
  }

  setActiveSlide(mediaId) {
    const slides = Array.from(this.viewer.querySelectorAll('[data-media-id]'));
    const targetIndex = slides.findIndex(slide => slide.dataset.mediaId === mediaId);
    if (targetIndex === -1) return;

    this.viewer.goTo(targetIndex);
  }

  setActiveThumbnail(activeItem) {
    if (!activeItem) return;

    const items = this.thumbnails.querySelectorAll('[data-target]');

    items.forEach(item => { 
      item.removeAttribute('aria-current');
      item.classList.remove('is-active');
    });

    const button = activeItem.querySelector('button');
    button.setAttribute('aria-current', 'true');
    activeItem.classList.add('is-active');

    // Scroll thumbnail into view
    const slider = this.thumbnails.slider;
    if (!slider) return;

    const isVisible = activeItem.offsetLeft >= slider.scrollLeft && activeItem.offsetLeft + activeItem.offsetWidth <= slider.scrollLeft + slider.clientWidth;

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (!isVisible) {
      slider.scrollTo({
        left: activeItem.offsetLeft,
        behavior: prefersReducedMotion ? 'auto' : 'smooth'
      });
    }
  }

  announceSlide(index) {
    if (!this.liveRegion) return;

    const total = this.viewer.querySelectorAll('[data-media-id]').length;
    this.liveRegion.textContent = '';
    setTimeout(() => {
      this.liveRegion.textContent = `Image ${index} of ${total} selected`;
    }, 50);
  }
}

if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', MediaGallery);
}